export const GlassMasthead = ({ text = "ROOTS", className = "", dark = false, style }) => (
  <span className={`glass-text ${dark ? "glass-text-dark" : ""} ${className}`} data-text={text} style={style} aria-label={text}>
    {text}
  </span>
);
